export default __webpack_public_path__ + "static/media/makanerp_attendance.151af21b.jpg";